import { Component, OnInit } from '@angular/core';
import { DashboarddemoService } from '../Dashboad1.service';
import { environment } from 'src/environments/environment';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-learnings1',
  templateUrl: './learnings.component.html',
  styleUrls: ['./learnings.component.css']
})
export class LearningsdemoComponent implements OnInit {
  userId: any;
  data: any;
  employeeId: number;
  length: number;

  constructor(private service: DashboarddemoService, private router: Router) { }

  ngOnInit() {
    
    this.userId = localStorage.getItem('userId');
    this.employeeId = parseInt(localStorage.getItem('Id'))
    this.getMyLearningsOfEmployee(this.userId, this.employeeId);
  }
  getMyLearningsOfEmployee(userId: number, employeeId: number) {
    
    this.service.getMyLearningsOfEmployee(userId, employeeId).subscribe(x => {
      this.data = x;
    })

  }
  navigatetoESD() {

    window.open(environment.esdMyLearningUrl + '/programs')

  }
  navigatetoESDId(num: number) {
    const url = environment.esdMyLearningUrl + '/programs/' + num;
    window.open(url)
  }

}
